import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import NavbarAuth from "./components/NavbarAuth";
import ServicesMecanique from "./pages/ServicesMecanique";
import ServicesCarrosserie from "./pages/ServicesCarrosserie";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Employee from "./pages/Employee";
import Estimation from "./pages/Estimation";
import GestionRendezVous from "./pages/GestionRendezVous";
import GestionStock from "./pages/GestionStock";
import TimeCard from "./pages/TimeCard";
 



export default function App() {
  const [language, setLanguage] = useState("fr");
  const location = useLocation();
  const isAuthenticated = !!localStorage.getItem('userData');
  
  // Liste des paths où NavbarAuth doit s'afficher
  const authPaths = ["/accueil", "/employee", "/stock", "/estimation", "/rendez-vous", "/Time-Card"];
  
  // Liste des paths où aucune navbar ne doit s'afficher
  const noNavbarPaths = ["/login"];

  return (
    <>
      {/* Logique d'affichage des navbars */}
      {isAuthenticated && authPaths.includes(location.pathname) ? (
        <NavbarAuth  />
      ) : !noNavbarPaths.includes(location.pathname) && (
        <Navbar language={language} setLanguage={setLanguage} />
      )}

      <Routes>
        <Route path="/" element={<Home language={language} />} />
        <Route path="/services-mecanique" element={<ServicesMecanique language={language} />} />
        <Route path="/services-carrosserie" element={<ServicesCarrosserie language={language} />} />
        <Route path="/login" element={<Login />} />
        
        {/* Routes avec NavbarAuth */}
        <Route path="/employee" element={<Employee />} />
        <Route path="/stock" element={<GestionStock/>} />
        <Route path="/estimation" element={<Estimation />} />
        <Route path="/rendez-vous" element={<GestionRendezVous/>} />
        <Route path="/Time-Card" element={<TimeCard/>} />

      </Routes>
    </>
  );
}